var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form-select", {
    attrs: {
      label: _vm.option.name,
      options: _vm.option.values,
      "display-by": "label",
      "track-as-integer": true,
      bold: true,
    },
    model: {
      value: _vm.selected.value,
      callback: function ($$v) {
        _vm.$set(_vm.selected, "value", $$v)
      },
      expression: "selected.value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }